import { render, staticRenderFns } from "./TwoColumnBanner.vue?vue&type=template&id=397625ac&scoped=true&"
import script from "./TwoColumnBanner.vue?vue&type=script&lang=js&"
export * from "./TwoColumnBanner.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnBanner.vue?vue&type=style&index=0&id=397625ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397625ac",
  null
  
)

export default component.exports